import { Form, Input, Select, Spin, Table } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOrdinalSuffix } from "../../../utils";
import useModalToggle from "../../../custom_hooks/useModalToggle";
import { useNavigate } from "react-router-dom";
import { fetchData, fetchMyUsers } from "../../../features/fetch/fetchSlice";
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";
import CardLoading from "../../../components/CardLoading";

export default function WalletUsers({ setactive }) {
  const { open, handleCancel, handleOpen } = useModalToggle();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const url = "api/v1/customers/fetch-wallet-users";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const { myUsersData } = useSelector((state) => state.fetch);
  const { saving } = useSelector((state) => state.save);
  const { walletObj } = useSelector((state) => state.obj);
  const { refetchKey } = useSelector((state) => state.global);

  const [dataSource, setDataSource] = useState([]);
  const [showBorder, setshowBorder] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [editingKey, setEditingKey] = useState("");

  const newUserData = myUsersData?.filter(
    (item) => !dataSource?.some((ds) => ds?.wuUsrId === item?.usrId)
  );

  const normalizeWalletUsers = (walletUsers) =>
    walletUsers?.map((item) => ({
      mbiId: item?.wuId,
      wuUsrId: item?.wuUsrId,
      isFromBackend: true,
    }));

  function handleRemove() {
    const updatedDataSource = dataSource?.filter(
      (item) => !selectedRowKeys.includes(item?.mbiId)
    );
    setSelectedRowKeys([]);
    setDataSource(updatedDataSource);
  }

  async function handleFetch() {
    await dispatch(
      fetchData({
        url: url,
        wuWalId: walletObj?.walId,
        limit: null,
        start: 0,
      })
    );
  }

  const EditableContext = React.createContext(null);
  const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
      <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
          <tr {...props} />
        </EditableContext.Provider>
      </Form>
    );
  };

  const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    setEditingKey,
    editingKey,
    ...restProps
  }) => {
    const editing = record?.mbiId === editingKey;
    const inputRef = useRef(null);
    const form = useContext(EditableContext);

    useEffect(() => {
      if (editing) {
        inputRef.current?.focus();
      }
    }, [editing]);

    const toggleEdit = () => {
      form.setFieldsValue({ ...record });
      setEditingKey(record?.mbiId);
    };

    const save = async () => {
      try {
        const values = await form.validateFields();
        let row = { ...record, ...values };
        toggleEdit();
        handleSave(row);
        setEditingKey("");
      } catch (errInfo) {
        console.log("Save failed:", errInfo);
      }
    };

    let childNode = children;
    if (editable) {
      childNode = editing ? (
        dataIndex === "wuUsrId" ? (
          <Form.Item
            rules={[{ required: true, message: "Field is required" }]}
            className="table-form-item"
            style={{ margin: 0 }}
            name={dataIndex}
          >
            <Select
              onBlur={save}
              ref={inputRef}
              placeholder="Select actor"
              options={newUserData?.map((item) => ({
                label: `${item?.usrFirstName} ${item?.usrLastName}`,
                value: item?.usrId,
              }))}
            />
          </Form.Item>
        ) : (
          <Form.Item
            rules={[{ required: true, message: "Field is required" }]}
            className="table-form-item"
            style={{ margin: 0 }}
            name={dataIndex}
          >
            <Input
              placeholder="Enter value"
              ref={inputRef}
              variant="borderless"
              onPressEnter={save}
              onBlur={save}
            />
          </Form.Item>
        )
      ) : (
        <div
          className="editable-cell-value-wrap"
          style={{ paddingRight: 24 }}
          onClick={() => toggleEdit()}
        >
          {children}
        </div>
      );
    }
    return <td {...restProps}>{childNode}</td>;
  };

  const handleAdd = async () => {
    const hasEmptyName = dataSource?.some(
      (item) => !item?.wuUsrId || item?.wuUsrId === "Select actor"
    );
    if (hasEmptyName) return;

    const newId = new Date().getTime();
    const newData = {
      mbiId: newId,
      wuUsrId: "Select actor",
      isFromBackend: false,
    };
    setDataSource([...dataSource, newData]);
    setEditingKey(newId);
  };

  const defaultColumns = [
    {
      title: "Actor Name",
      dataIndex: "wuUsrId",
      editable: true,
      render: (value) => {
        const approver = myUsersData?.find((u) => u?.usrId === value);
        return approver
          ? `${approver?.usrFirstName} ${approver?.usrLastName}`
          : "No actor";
      },
    },
  ];

  const handleSave = async (row) => {
    const newData = [...dataSource];
    const index = newData?.findIndex((item) => row?.mbiId === item?.mbiId);
    const item = newData[index];
    newData?.splice(index, 1, { ...item, ...row });
    setDataSource(newData);
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const columns = defaultColumns?.map((col) =>
    col.editable
      ? {
          ...col,
          onCell: (record) => ({
            record,
            editable: col.editable,
            dataIndex: col.dataIndex,
            title: col.title,
            handleSave,
            editingKey,
            setEditingKey,
          }),
        }
      : col
  );

  async function fetchMyUsersData() {
    await dispatch(fetchMyUsers({ url: "api/v2/users/fetch-Identities" }));
  }

  const handleSubmit = async () => {
    const hasInvalid = dataSource?.some(
      (item) => !item?.wuUsrId || item?.wuUsrId === "Select actor"
    );

    if (hasInvalid) {
      toast.error("Please select all actors before submitting");
      return;
    }

    const wuUsrIds = dataSource?.map((item) => item?.wuUsrId);
    const res = await dispatch(
      save({
        wuWalId: walletObj?.walId,
        wuUsrIds,
        url: "api/v1/customers/save-wallet-users",
      })
    );
    if (res?.payload?.success) {
      toast.success(res?.payload?.messages?.message);
      setactive("2");
      handleFetch();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handlePrevious = async () => {
    await setactive("2");
  };

  useEffect(() => {
    if (refetchKey == 3) {
      fetchMyUsersData();
      handleFetch();
    }
  }, [refetchKey]);


  
  useEffect(() => {
    if (data) {
      setDataSource(normalizeWalletUsers(data));
    } else {
      setDataSource([]);
    }
  }, [data]);
  if (loading  ) return <CardLoading />;
  return (
    <div className="lg:w-[40%] w-full">
      <span className="paragraph_1">
        This is a list of all users allowed to operate on this wallet
      </span>

      <div className="max-w-full w-full overflow-x-auto mt-[1.25rem]">
        <section>
          <Table
            className="editable_table"
            size="large"
            bordered={false}
            rowSelection={{
              selectedRowKeys,
              onChange: (keys) => setSelectedRowKeys(keys),
            }}
            columns={columns}
            components={components}
            dataSource={dataSource}
            rowKey={(record) => record.mbiId}
            pagination={{
              defaultPageSize: 10,
              hideOnSinglePage: true,
              pageSizeOptions: [10, 20, 50, 100],
            }}
            footer={() => (
              <div className="flex items-center w-full justify-between gap-[1.25rem] p-[1rem]">
                {selectedRowKeys.length > 0 ? (
                  <button
                    type="button"
                    onClick={handleRemove}
                    className="flex items-center gap-[.5rem]"
                  >
                    <div className="black-round-btn !bg-[#fff] !border !border-[#C72C3B]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M20.25 4.5H16.5V3.75C16.5 3.15326 16.2629 2.58097 15.841 2.15901C15.419 1.73705 14.8467 1.5 14.25 1.5H9.75C9.15326 1.5 8.58097 1.73705 8.15901 2.15901C7.73705 2.58097 7.5 3.15326 7.5 3.75V4.5H3.75C3.55109 4.5 3.36032 4.57902 3.21967 4.71967C3.07902 4.86032 3 5.05109 3 5.25C3 5.44891 3.07902 5.63968 3.21967 5.78033C3.36032 5.92098 3.55109 6 3.75 6H4.5V19.5C4.5 19.8978 4.65804 20.2794 4.93934 20.5607C5.22064 20.842 5.60218 21 6 21H18C18.3978 21 18.7794 20.842 19.0607 20.5607C19.342 20.2794 19.5 19.8978 19.5 19.5V6H20.25C20.4489 6 20.6397 5.92098 20.7803 5.78033C20.921 5.63968 21 5.44891 21 5.25C21 5.05109 20.921 4.86032 20.7803 4.71967C20.6397 4.57902 20.4489 4.5 20.25 4.5ZM9 3.75C9 3.55109 9.07902 3.36032 9.21967 3.21967C9.36032 3.07902 9.55109 3 9.75 3H14.25C14.4489 3 14.6397 3.07902 14.7803 3.21967C14.921 3.36032 15 3.55109 15 3.75V4.5H9V3.75ZM18 19.5H6V6H18V19.5ZM10.5 9.75V15.75C10.5 15.9489 10.421 16.1397 10.2803 16.2803C10.1397 16.421 9.94891 16.5 9.75 16.5C9.55109 16.5 9.36032 16.421 9.21967 16.2803C9.07902 16.1397 9 15.9489 9 15.75V9.75C9 9.55109 9.07902 9.36032 9.21967 9.21967C9.36032 9.07902 9.55109 9 9.75 9C9.94891 9 10.1397 9.07902 10.2803 9.21967C10.421 9.36032 10.5 9.55109 10.5 9.75ZM15 9.75V15.75C15 15.9489 14.921 16.1397 14.7803 16.2803C14.6397 16.421 14.4489 16.5 14.25 16.5C14.0511 16.5 13.8603 16.421 13.7197 16.2803C13.579 16.1397 13.5 15.9489 13.5 15.75V9.75C13.5 9.55109 13.579 9.36032 13.7197 9.21967C13.8603 9.07902 14.0511 9 14.25 9C14.4489 9 14.6397 9.07902 14.7803 9.21967C14.921 9.36032 15 9.55109 15 9.75Z"
                          fill="#C72C3B"
                        />
                      </svg>
                    </div>
                    <span className="role_btn_text !text-[#C72C3B]">
                      Remove selected
                    </span>
                  </button>
                ) : (
                  <button
                    type="button"
                    disabled={dataSource?.some(
                      (item) =>
                        !item?.wuUsrId || item?.wuUsrId === "Select actor"
                    )}
                    onClick={handleAdd}
                    className="flex items-center gap-[.5rem]"
                  >
                    <div className="black-round-btn">
                      <svg
                        className="z-[100]"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M11.9998 4.7998L11.9998 19.1998M19.1998 11.9998L4.7998 11.9998"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                    <span className="role_btn_text">Add</span>
                  </button>
                )}
              </div>
            )}
          />
        </section>
      </div>

      <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
        <div className="justify-start"></div>
        <div className="justify-end flex items-center gap-x-2">
          <div className="w-[150px]">
            <button
              key="back"
              type="button"
              onClick={handlePrevious}
              className="cstm-btn"
            >
              Previous
            </button>
          </div>

          <div className="w-[150px]">
            <button
              key="submit"
              type="button"
              onClick={handleSubmit}
              className="cstm-btn-2"
              disabled={saving}
            >
              {saving ? <Spin /> : " Submit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
